export const openBlobFile = (file: Blob | undefined, target = '_blank') => {
  if (typeof file === 'undefined') return
  const url = URL.createObjectURL(file)
  window.open(url, target)
}
